document.addEventListener('DOMContentLoaded', function () {
	const header = document.querySelector('[data-site-header]');
	const adminToolbarPlaceholder = document.querySelector('[data-admin-toolbar-placeholder]');

	const initLocationDirectorySearch = () => {
		const searchInput = document.querySelector('[data-location-search-input]');
		if (!searchInput) {
			return;
		}

		const articles = Array.from(document.querySelectorAll('[data-country-card]')).map(article => {
			const items = Array.from(article.querySelectorAll('[data-location-item]'));
			const countElement = article.querySelector('[data-country-count]');
			const totalCount = countElement ? Number.parseInt(countElement.dataset.countryTotal || '', 10) || items.length : items.length;

			return { article, items, countElement, totalCount };
		});

		if (articles.length === 0) {
			return;
		}

		const summary = document.querySelector('[data-location-search-summary]');
		const summaryCount = summary ? summary.querySelector('[data-location-results-count]') : null;
		const summaryTotal = summary ? summary.querySelector('[data-location-results-total]') : null;
		const emptyState = document.querySelector('[data-location-search-empty]');
		const totalLocations = articles.reduce((sum, entry) => sum + entry.totalCount, 0);

		searchInput.dataset.locationTotal = totalLocations;

		if (summaryTotal) {
			summaryTotal.textContent = totalLocations;
		}

		if (summaryCount) {
			summaryCount.textContent = totalLocations;
		}

		const normalize = value => value.trim().toLowerCase();
		const pluralize = (count, singular, plural) => {
			const pluralForm = plural || `${singular}s`;
			return `${count} ${count === 1 ? singular : pluralForm}`;
		};

		const filterLocations = () => {
			const query = normalize(searchInput.value);
			const hasQuery = query.length > 0;
			let totalMatches = 0;

			articles.forEach(entry => {
				const { article, items, countElement, totalCount } = entry;
				let matchesWithinArticle = 0;

				items.forEach(item => {
					const anchor = item.querySelector('[data-location-search]');
					const searchText = anchor ? (anchor.dataset.locationSearch || '').toLowerCase() : '';
					const match = !hasQuery || searchText.includes(query);

					item.hidden = !match;

					if (match) {
						matchesWithinArticle += 1;
					}
				});

				const hasMatches = matchesWithinArticle > 0;

				article.hidden = !hasMatches;
				article.style.display = hasMatches ? '' : 'none';

				if (hasMatches) {
					article.removeAttribute('aria-hidden');
				} else {
					article.setAttribute('aria-hidden', 'true');
				}

				if (countElement) {
					let text;
					if (!hasQuery || matchesWithinArticle === totalCount) {
						text = pluralize(totalCount, 'location');
					} else {
						const totalLabel = totalCount === 1 ? 'location' : 'locations';
						text = `${pluralize(matchesWithinArticle, 'location')} of ${totalCount} ${totalLabel}`;
					}
					countElement.textContent = text;
				}

				if (hasMatches) {
					totalMatches += matchesWithinArticle;
				}
			});

			if (summaryCount) {
				summaryCount.textContent = totalMatches;
			}

			if (summaryTotal) {
				summaryTotal.textContent = totalLocations;
			}

			if (summary) {
				summary.dataset.locationSearchHasQuery = hasQuery ? 'true' : 'false';
			}

			if (emptyState) {
				emptyState.hidden = totalMatches > 0;
			}

			searchInput.setAttribute('aria-invalid', hasQuery && totalMatches === 0 ? 'true' : 'false');
		};

		searchInput.addEventListener('input', filterLocations);
		searchInput.addEventListener('search', filterLocations);

		filterLocations();
	};

	initLocationDirectorySearch();

	const initHeaderAuth = () => {
		const authUrl = (header && header.dataset.headerAuthUrl) ||
			(adminToolbarPlaceholder && adminToolbarPlaceholder.dataset.headerAuthUrl);

		if (!authUrl || !window.fetch) return;

		const authLinks = header ? Array.from(header.querySelectorAll('[data-header-auth-link]')) : [];
		const primaryLink = authLinks[0];
		const primaryLabelElement = primaryLink && (primaryLink.querySelector('[data-header-auth-label]') || primaryLink);
		let defaultHref = primaryLink && (primaryLink.dataset.headerAuthDefaultHref || primaryLink.href);
		// Shared HTML has a clean path-only fallback. Preserve this browser's
		// current search/hash at sign-in without embedding visitor state in it.
		if (defaultHref) {
			const loginUrl = new URL(defaultHref, window.location.origin);
			const atAuthPage = ['/login', '/signup'].includes(window.location.pathname);
			if (!atAuthPage) {
				loginUrl.searchParams.set('return_to', window.location.pathname + window.location.search + window.location.hash);
			}
			defaultHref = loginUrl.pathname + loginUrl.search;
			authLinks.forEach(link => { link.href = defaultHref; });
		}
		const defaultLabel = primaryLink && (primaryLink.dataset.headerAuthDefaultLabel || primaryLabelElement.textContent.trim());

		const abortController = typeof AbortController === 'undefined' ? null : new AbortController();
		const timeoutId = window.setTimeout(() => {
			if (abortController) {
				abortController.abort();
			}
		}, 4000);

		const applyState = (label, href, state) => {
			authLinks.forEach(link => {
				const labelElement = link.querySelector('[data-header-auth-label]') || link;
				labelElement.textContent = label;
				link.href = href;
				link.dataset.headerAuthState = state;
			});
		};

		fetch(authUrl, {
			headers: { Accept: 'application/json' },
			credentials: 'include',
			signal: abortController ? abortController.signal : undefined
		})
			.then(response => {
				window.clearTimeout(timeoutId);
				if (!response.ok) throw new Error('Header auth status failed');
				return response.json();
			})
			.then(data => {
				if (!data || typeof data.authenticated !== 'boolean') {
					return;
				}

				if (data.authenticated) {
					const nextHref = data.cta_path || defaultHref;
					const nextLabel = data.cta_label || defaultLabel;
					applyState(nextLabel, nextHref, 'authenticated');
				} else {
					applyState(defaultLabel, defaultHref, 'anonymous');
				}

				// Other planning tools can reconcile their private state after the
				// existing auth check, without a second identity request.
				const authState = {
					authenticated: data.authenticated,
					ctaPath: data.authenticated ? (data.cta_path || defaultHref) : defaultHref,
					ctaLabel: data.authenticated ? (data.cta_label || defaultLabel) : defaultLabel
				};
				window.TeamBuildingAuthState = authState;
				document.dispatchEvent(new CustomEvent('teambuilding:auth-state', { detail: authState }));

				if (
					data.show_admin_toolbar &&
					data.admin_toolbar_html &&
					adminToolbarPlaceholder &&
					adminToolbarPlaceholder.dataset.rendered !== 'true'
				) {
					adminToolbarPlaceholder.innerHTML = data.admin_toolbar_html;
					adminToolbarPlaceholder.hidden = false;
					adminToolbarPlaceholder.dataset.rendered = 'true';
				}
			})
			.catch(() => {
				window.clearTimeout(timeoutId);
				applyState(defaultLabel, defaultHref, 'error');
			});
	};

	initHeaderAuth();

	if (!header) return;

	const toggle = header.querySelector('[data-site-header-toggle]');
	const nav = header.querySelector('[data-site-header-nav]');
	const submenuToggles = header.querySelectorAll('[data-submenu-toggle]');
	const breakpoint = window.matchMedia('(min-width: 1280px)');

	const collapseSubmenus = () => {
		submenuToggles.forEach(button => button.setAttribute('aria-expanded', 'false'));
		header.querySelectorAll('[data-nav-item].is-open').forEach(item => item.classList.remove('is-open'));
	};

	const closeNav = (restoreFocus = false) => {
		header.classList.remove('is-open');
		if (toggle) {
			toggle.setAttribute('aria-expanded', 'false');
			toggle.setAttribute('aria-label', 'Open navigation');
			if (restoreFocus) toggle.focus();
		}
		collapseSubmenus();
	};

	if (toggle && nav) {
		toggle.addEventListener('click', () => {
			const willOpen = !header.classList.contains('is-open');
			if (willOpen) {
				header.classList.add('is-open');
				toggle.setAttribute('aria-expanded', 'true');
				toggle.setAttribute('aria-label', 'Close navigation');
			} else {
				closeNav();
			}
		});
	}

	submenuToggles.forEach(button => {
		const navItem = button.closest('[data-nav-item]');
		if (!navItem) return;

		button.addEventListener('click', () => {
			const expanded = button.getAttribute('aria-expanded') === 'true';

			if (!expanded) {
				const parentList = navItem.parentElement;
				if (parentList) {
					Array.from(parentList.children).forEach(sibling => {
						if (sibling !== navItem && sibling.matches('[data-nav-item].is-open')) {
							sibling.classList.remove('is-open');
							const siblingToggle = sibling.querySelector('[data-submenu-toggle]');
							if (siblingToggle) siblingToggle.setAttribute('aria-expanded', 'false');
						}
					});
				}
			}

			navItem.classList.toggle('is-open', !expanded);
			button.setAttribute('aria-expanded', (!expanded).toString());
		});
	});

	const handleViewportChange = event => {
		if (event.matches) {
			closeNav();
		}
	};

	if (breakpoint.addEventListener) {
		breakpoint.addEventListener('change', handleViewportChange);
	} else if (breakpoint.addListener) {
		breakpoint.addListener(handleViewportChange);
	}

	document.addEventListener('keydown', event => {
		if (event.key === 'Escape' && header.classList.contains('is-open')) {
			closeNav(true);
		}
	});

	header.addEventListener('click', event => {
		if (event.target.closest('[data-find-activity], [data-shortlist-open]')) closeNav();
	});

	document.addEventListener('focusin', event => {
		if (!header.contains(event.target) && header.classList.contains('is-open')) closeNav();
	});

	document.addEventListener('click', event => {
		if (!header.contains(event.target) && header.classList.contains('is-open')) {
			closeNav();
		}
	});
});

// jQuery-dependent features (only run if jQuery is loaded)
if (typeof $ !== 'undefined' && typeof jQuery !== 'undefined') {
	$(document).ready(function () {
		$('.admin-header .rst-menu-trigger').click(function () {
			$('.sidebar').toggleClass('active');
			$("body").toggleClass("open-menu");
			return false;
		});

		$('.switch input').change(function () {
			if ($(this).is(':checked')) {
				$(this).closest('.toggle-type').addClass('checked');
			} else {
				$(this).closest('.toggle-type').removeClass('checked');
			}
		});

	let index = 1;

	const on = (listener, query, fn) => {
		document.querySelectorAll(query).forEach(item => {
			item.addEventListener(listener, el => {
				fn(el);
			});
		});
	}

	// Click on .selectBtn
	on('click', '.selectBtn', item => {
		// Remove .toggle from all .selectDropdown elements
		document.querySelectorAll('.selectDropdown').forEach(dropdown => {
			if (dropdown !== item.target.nextElementSibling) {
				dropdown.classList.remove('toggle');
			}
		});

		const next = item.target.nextElementSibling;
		next.classList.toggle('toggle');
		next.style.zIndex = index++;
	});

	on('click', '.option', item => {
		document.querySelectorAll('.selectDropdown').forEach(dropdown => {
			dropdown.classList.remove('toggle');
		});

		item.target.parentElement.querySelectorAll('.option').forEach(option => {
			option.classList.remove('selected');
		});

		item.target.classList.add('selected');

		const parent = item.target.closest('.select').children[0];
		const newDataType = item.target.getAttribute('data-type');

		if (parent.getAttribute('data-type') !== newDataType) {
			parent.setAttribute('data-type', newDataType);
			parent.innerText = item.target.innerText;
		}

		// Find the .selectBtn element within the same .select container
		const selectBtn = item.target.closest('.select').querySelector('.selectBtn');
		// Add the .active class to the .selectBtn
		// selectBtn.classList.add('active');
	});

		$(document).on('click', function (event) {
			if (!$(event.target).closest('.selectDropdown, .box-filter').length) {
				$('.selectDropdown').removeClass('toggle');
			}
		});


		jQuery(document).ready(function () {
		function checkWindowSize() {
			var windowWidth = jQuery(window).width();

			// Go by link on click on large screens
			jQuery('.box-top .has-menu-children > a').off('click');

			if (windowWidth <= 768) {
				// Toggle menu on click on small screens
				jQuery('.box-top .has-menu-children > a').on('click', function (event) {
					event.preventDefault(); // Prevent default action for a
					var parent = jQuery(this).closest('.has-menu-children');
					jQuery('.box-top .has-menu-children').not(parent).removeClass('active');
					parent.toggleClass('active');
				});
			}

			// Add hover event listeners to .has-menu-children on big screens
			if (windowWidth > 768) {
				jQuery('.box-top .has-menu-children').off('mouseenter mouseleave').hover(
					function () {
						jQuery(this).addClass('active');
					},
					function () {
						jQuery(this).removeClass('active');
					}
				);
			} else {
				jQuery('.box-top .has-menu-children').off('mouseenter mouseleave'); // Remove hover events for smaller screens
			}

			// Remove active class when clicking outside of .has-menu-children
			jQuery(document).off('click.outside').on('click.outside', function (event) {
				if (!jQuery(event.target).closest('.box-top .has-menu-children').length) {
					jQuery('.box-top .has-menu-children').removeClass('active');
				}
			});

		}

		checkWindowSize();

	jQuery(window).resize(function () {
		checkWindowSize();
	});
});

	}); // End of $(document).ready
} // End of jQuery check
